import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { entite } from 'src/app/models/entite';
import { entiteAdd } from 'src/app/models/entiteAdd';
import { formejuridique } from 'src/app/models/formjuridique';
import { typeSociete } from 'src/app/models/typeSociete';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-form-entite-modif',
  templateUrl: './form-entite-modif.component.html',
  imports: [CommonModule,FormsModule,ToastModule,ButtonModule,ReactiveFormsModule,InputTextModule,SelectButtonModule,SelectModule,ButtonModule],
  styleUrls: ['./form-entite-modif.component.scss']
})
export class FormEntiteModifComponent implements OnInit {
  libelleselected: string = '';
  entites!: entite[];
  formjuridlis!: formejuridique[];
  selectedFormejurid!: formejuridique;
  entitegetter!: entite;
  selectedAdress1!: string;
  selectedAdress2!: string;
  selectedAdress3!: string;
  selectedExterne!: any;
  selectedVille!: string;
  selectedCodePostal!: string;
  selectedTel!: any;
  selectedstats!: number;
  constructor(public root: Router, public messageService:
    MessageService,
    public shared: shareOpeSevices, private fb: FormBuilder,
    private entiteservice: EntitebackService) {
    this.monentite = new entiteAdd();
  };
  monentite!: entiteAdd;
  selectedEntitePere!: entite;
  typesciete!: typeSociete[];
  selecteTypesociete!: typeSociete;
  ngOnInit() {





    this.shared.noeudficheEntite$.subscribe(data => {

      this.entiteservice.getAllEntites().subscribe((dataret: entite[]) => {
        this.entites = dataret;
        this.entiteservice.getEntitebyId(data.parent.data.id).subscribe((resultat: entite) => {
          this.entites[0] = resultat;
          this.selectedEntitePere = this.entites[0];
        })

      });

      this.entiteservice.getEntitebyId(data.data.id).subscribe((resultat: entite) => {
        this.entiteservice.getTypeSociete().subscribe((dataret: typeSociete[]) => {
          this.typesciete = dataret;
          this.typesciete[0] = dataret.filter(item => item.libelle == resultat.type)[0];
          this.selecteTypesociete = this.typesciete[0];
        });

        this.entiteservice.getFormjuridique().subscribe((data: formejuridique[]) => {
          this.formjuridlis = data;
          this.formjuridlis[0] = data.filter(item => item.a1code == resultat.formeJuridique)[0];;
          this.selectedFormejurid = this.formjuridlis[0];
        });

        this.entitegetter = resultat;
        this.libelleselected = this.entitegetter.libelle;
        this.selectedAdress1 = this.entitegetter.adresse1;
        this.selectedAdress2 = this.entitegetter.adresse2;
        this.selectedAdress3 = this.entitegetter.adresse3;
        this.selectedExterne = this.entitegetter.ext;
        this.selectedVille = this.entitegetter.ville;
        this.selectedCodePostal = this.entitegetter.codePostal;
        this.monentite.numEntite = this.entitegetter.numEntite;
        this.selectedTel = this.entitegetter.tel;
        this.selectedstats = this.entitegetter.statut;
      })

    })
  }


  entiteForm = this.fb.group({
    nomentite: ['', Validators.required],
    num_pere: [0],
    type: [""],
    adress1: ['', Validators.required],
    adress2: [''],
    adress3: [''],
    ext: [''],
    telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    formeJuridique: [''],
    codepostal: [12345, { validators: [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')] }],
    statut: [0],
    ville: ['', Validators.required]
  });

  uppdateENtite() {
    this.entiteForm.value.formeJuridique = this.selectedFormejurid?.libelle;
    this.monentite.libelle = this.libelleselected;
    this.monentite.adresse1 = this.selectedAdress1;
    this.monentite.adresse2 = this.selectedAdress2;
    this.monentite.adresse3 = this.selectedAdress3;
    this.monentite.ext = this.selectedExterne;
    this.monentite.ville = this.selectedVille;
    this.monentite.num_pere = this.selectedEntitePere?.numEntite;
    this.monentite.type = this.selecteTypesociete?.a1CODE;
    this.monentite.code_postal = this.selectedCodePostal;
    this.monentite.formeJuridique = this.selectedFormejurid?.a1code;
    // this.monentite.statut  = this.selectedstats;
    this.monentite.statut = this.entiteForm.value.statut == 0 ? 0 : 1;
    this.monentite.tel = this.selectedTel;
    this.entiteservice.updateEntite(this.monentite).subscribe({

      next: (response: any) => {
        if (response.status == 200 && response.body !== null) {

          this.messageService.add({ severity: 'success', detail: response.body?.libelle + ' a été modifié avec succés' });
        }

        else if (response.body === null) {

          this.messageService.add({ severity: 'warn', detail: "Erreur lors de la modification !" });
        }
      },
      error: (err: HttpErrorResponse) => {

        this.messageService.add({ severity: 'warn', detail: err.error.message + ' Erreur' })
      }

    })


  }



}
